const initMetadataManager = ()=>{
    let locationPins = {};
    let hotelOnMap = {};
    return {
        getLocationPinList: ()=>Object.values(locationPins),
        getHotelOnMapList: ()=>Object.values(hotelOnMap),
        appendNewPinToList: ({ singlePin, listOfPins = [] })=>{
            if (0 !== listOfPins.length) listOfPins.forEach((pin)=>{
                locationPins = {
                    ...locationPins,
                    [pin.name]: pin
                };
            });
            else if (singlePin) locationPins = {
                ...locationPins,
                [singlePin.name]: singlePin
            };
        },
        setHotelPinOnMap: (list)=>{
            locationPins = {};
            list.forEach((hotel)=>{
                if (hotel.hotelId) hotelOnMap = {
                    ...hotelOnMap,
                    [hotel.hotelId]: hotel
                };
                else if (hotel.name) hotelOnMap = {
                    ...hotelOnMap,
                    [hotel.name]: hotel
                };
            });
        },
        reset: ()=>{
            hotelOnMap = {};
            locationPins = {};
        }
    };
};
const inlineMetadataManager = initMetadataManager();
export { initMetadataManager, inlineMetadataManager };
